// src/components/layout/Layout.js
import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

// Vos imports existants
import Navbar from './Navbar';
import Footer from './Footer';
// --- AJOUTER L'IMPORT DU CHATBOT ICI ---
import ChatWidget from '../chat/ChatWidget'; 
import OnboardingGuide from '../onboarding/OnboardingGuide';
import './Layout.css';

const Layout = () => {
    const { isAuthenticated } = useAuth();
    const [isNavbarVisible, setIsNavbarVisible] = useState(true);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="app-layout">
            {isNavbarVisible && <Navbar />}

            <main className="main-content">
                <Outlet context={{ setIsNavbarVisible }} />
            </main>

            {isNavbarVisible && <Footer />}

            {/* Visite guidée : montée une seule fois, disponible sur toutes les pages protégées */}
            <OnboardingGuide />
        </div>
    );
};

export default Layout;